<template>
  <v-row dense>
    <v-col cols="12" md="4">
      <v-autocomplete
        v-model="value.servidores.selecionado"
        :items="value.servidores.opcoes"
        class="mr-2"
        chips
        small-chips
        deletable-chips
        item-text="nomeAvaliado"
        label="Servidores"
        placeholder="Digite para pesquisar..."
        multiple
        prepend-icon="supervisor_account"
        return-object
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
        v-model="value.lista.selecionado"
        :items="value.lista.opcoes"
        :item-text="custom.itemText"
        :label="custom.label"
        :prepend-icon="custom.icone"
        class="mr-2"
        chips
        small-chips
        deletable-chips
        placeholder="Digite para pesquisar..."
        multiple
        return-object
      />
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
        v-model="value.notas.selecionado"
        :items="value.notas.opcoes"
        chips
        small-chips
        deletable-chips
        item-text="descricao"
        item-value="id"
        label="Notas"
        placeholder="Digite para pesquisar..."
        multiple
        prepend-icon="grade"
        return-object
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AvaliacaoFilter',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        servidores: {
          opcoes: [],
          selecionado: [],
        },
        lista: {
          opcoes: [],
          selecionado: [],
        },
        notas: {
          opcoes: [],
          selecionado: [],
        },
      }),
    },
    perspectiva: {
      type: String,
      required: true,
    },
  },

  computed: {
    custom() {
      if (this.perspectiva === 'COMPORTAMENTAL') {
        return {
          icone: 'thumb_up',
          label: 'Comportamentos',
          itemText: 'descricaoAtualizada',
        };
      }

      return {
        icone: 'recent_actors',
        label: 'Responsabilidades',
        itemText: 'tituloAtual',
      };
    },
  },
};
</script>
